<!--
 * @Description: 上传文件 拖拽
 * @Author: cxh
 * @Date: 2022-05-24 16:25:08
 * @LastEditTime: 2023-04-14 10:46:58
 * @LastEditors: mdb
-->
<template>
  <div>
    <a-upload
      v-bind="$attrs"
      :file-list="fileList"
      :custom-request="customRequest"
      :before-upload="beforeUpload"
      @remove="remove"
    >
      <div style="display: flex" v-if="!view">
        <a-button v-if="!props.disabled" type="primary">
          {{ uploadText ? uploadText : $t('btn.selectFile') }}
        </a-button>
        <span v-if="tipsComputed" class="tips" @click.stop="">{{ tipsComputed }}</span>
      </div>
      <template #itemRender="{ file, actions }">
        <!---温馨提示-->
        <div></div>
        <div
          style="display: flex; align-items: center"
          :class="[
            'upload-file-list',
            props.disabled ? 'upload-file-list-disabled' : 'upload-file-list-edit',
            'upload-file-list-view'
          ]"
        >
          <div
            :class="[file.status === 'error' ? 'error-files' : 'success-files']"
            :style="file.status === 'error' ? 'color: red' : ''"
            class="flex1"
          >
            <img class="world-time-item__img" :src="iconList[getFileType(file.name)]" style="margin-right: 4px" />
            <a href="javascript:;" @click="actions.download">{{ file.name }}</a>
          </div>
          <a v-if="!(props.disabled || view)" href="javascript:;" class="iconfont deleteIcon" @click="actions.remove">
            <img src="@/assets/deleteIcon.svg" alt="" />
          </a>
        </div>
      </template>
    </a-upload>
    <div v-if="uploadFile" class="upload-content">
      <div class="upload-progress">
        <a-progress :percent="progress" stroke-color="#3FAC46" status="active" :stroke-width="30" />
        <p class="upload-progress-percent" :style="{ left: progress + '%' }">{{ progress }}%</p>
      </div>
      <p>{{ uploadFile.name }}</p>
    </div>
  </div>
</template>
<script lang="ts" setup name="UploadFile">
import request from '@/utils/request'
import { computed, ref, watch } from 'vue'
import { Form } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import excel from '@/assets/uploadFile/excel.svg'
import pdf from '@/assets/uploadFile/pdf.svg'
import ppt from '@/assets/uploadFile/ppt.svg'
import txt from '@/assets/uploadFile/txt.svg'
import word from '@/assets/uploadFile/word.svg'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const iconList = ref<object>({
  excel: excel,
  pdf: pdf,
  ppt: ppt,
  txt: txt,
  word: word
})
type FileListTypes = {
  name: string
  uid: string
  status: string
  url: string
  response?: string
}
type UploadFileTypes = {
  name: string
  uid: string
  status: string
}
const props = defineProps({
  value: {
    type: [String, Array]
  },
  maxCount: {
    type: Number,
    default: 10
  },
  action: {
    type: String,
    default: '/base/resource/file/upload'
  },
  uploadText: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  tips: {
    type: String,
    default: ''
  },
  view: {
    type: Boolean
  },
  type: {
    type: String,
    default: 'edit' // 定义样式 detail 详情样式
  },
  valueType: {
    type: String,
    default: 'string' // 定义值格式 array 数组
  },
  accept: {
    type: String,
    default: '.xlsx,.xls,.doc,.docx,.pdf,.png,.jpg' // 定义样式 detail 详情样式
  },
  fileSize: {
    type: Number,
    default: 20 // 20M
  }
})
const tipsComputed = computed(() => {
  if (props.tips) {
    return props.tips
  }
  const { accept, maxCount, fileSize } = props
  return t('tips.importSizeFileType', { fileType: accept, fileNum: maxCount, fileSize })
})
const uploadFile = ref<UploadFileTypes>()
const formItemContext = Form.useInjectFormItemContext()
const progress = ref<number>(10)
const fileList = ref<FileListTypes[]>([])
const resultFileList = ref<string>('')
const emit = defineEmits(['update:value'])
const fileFormatter = (data: any) => {
  const name = data.split('/')
  let suffix = ''
  let contentType = ''
  try {
    const flieArr = name.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  suffix = suffix.toLocaleLowerCase() // 将后缀所有字母改为小写
  if (['jpg', 'jpeg'].find((item) => item === suffix)) {
    contentType = 'IMAGE/JPEG'
  } else if (['png'].find((item) => item === suffix)) {
    contentType = 'IMAGE/PNG'
  }

  const file: {
    name: string
    uid: string
    status: string
    url: string
    response: string
  } = {
    name: name[name.length - 1],
    uid: data,
    status: 'done',
    url: contentType.length === 0 ? data : data + '?response-content-type=' + contentType,
    response: '{"status": "success"}' // 服务端响应内容
  }
  return file
}
watch(
  () => props.value,
  (v) => {
    if (v) {
      let arr = []
      if (typeof v === 'string') {
        if (v !== resultFileList.value) {
          arr = v.split(',')
        }
      } else if (Array.isArray(v)) {
        if (v.join(',') !== resultFileList.value) {
          arr = v
        }
      }
      if (arr.length) {
        fileList.value = []
        arr.forEach((item) => {
          fileList.value?.push(fileFormatter(item))
        })
      }
    } else {
      resultFileList.value = ''
      fileList.value = []
    }
  },
  { immediate: true }
)

const change = () => {
  const url = fileList.value.map((item) => item.url)
  resultFileList.value = url.join(',')
  if (props.valueType === 'string') {
    emit('update:value', url.join(','))
  } else if (props.valueType === 'array') {
    emit('update:value', url)
  }
  formItemContext.onFieldChange()
}
const remove = (info: FileListTypes) => {
  fileList.value = fileList.value?.filter((i) => {
    return i.uid !== info.uid
  })
  change()
}

// updateName
const updateName = (name: string) => {
  // 唯一name
  const hasSome = fileList.value?.some((item) => item.name === name)
  let resultName = name
  const fileType = name.split('.')[1]
  const fileName = name.split('.')[0]
  if (hasSome) {
    let index = 2
    for (let i = 0; i < fileList.value.length; i++) {
      resultName = `${fileName}(${index}).${fileType}`
      const hasIndex = fileList.value?.findIndex((item) => item.name === resultName)
      if (hasIndex === -1) {
        break
      } else {
        index++
      }
    }
  }
  return resultName
}
const isTest = (fileName: string) => {
  if (props.accept) {
    const reg = new RegExp(`.(${props.accept.replace(/[.\s]/g, '').replace(/,/g, '|')})$`)
    return reg.test(fileName)
  } else {
    return true
  }
}
const beforeUpload = (file: any) => {
  if (fileList.value && props.maxCount === fileList.value.length) {
    DcMessage.warning(t('tips.importNumber', { fileNum: props.maxCount }))
    return false
  }
  if (!isTest(file.name)) {
    DcMessage.warning(t('tips.importFileType', { fileType: props.accept }))
    return false
  }
  const isLtM = file.size / 1024 / 1024 > props.fileSize
  if (isLtM) {
    DcMessage.warning(t('tips.importSize10', { fileSize: props.fileSize }))
    return false
  }
}
const customRequest = (file: any) => {
  const newName = updateName(file.file.name)
  const formData = new FormData()
  if (newName !== file.file.name) {
    const renameF = new File([file.file], newName)
    formData.append('files', renameF)
  } else {
    formData.append('files', file.file)
  }
  uploadFile.value = {
    uid: file.file.uid,
    name: newName,
    status: 'upload'
  }
  request({
    url: props.action,
    data: formData,
    method: 'POST',
    headers: {
      'Content-type': 'multipart/form-data'
    },
    onUploadProgress({ total, loaded }) {
      progress.value = 0
      progress.value = Math.round((loaded / (total * 2)) * 100)
    }
  })
    .then((res: any) => {
      if (res.data && res.data[0]) {
        fileList.value = [...fileList.value, fileFormatter(res.data[0])]
        console.log(fileList.value)
      }
      change()
    })
    .catch(() => {
      DcMessage.warning(t('tips.importError'))
    })
    .finally(() => {
      uploadFile.value = undefined
    })
}
const getFileType = (fileName: string) => {
  let suffix = ''
  try {
    const flieArr = fileName.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  if (!suffix) {
    return false
  }
  suffix = suffix.toLocaleLowerCase() // 将后缀所有字母改为小写
  // 匹配 excel
  const excelist = ['xls', 'xlsx']
  if (excelist.find((item) => item === suffix)) {
    return 'excel'
  }
  // 匹配 word
  const wordlist = ['doc', 'docx']
  if (wordlist.find((item) => item === suffix)) {
    return 'word'
  }
  // 匹配 pdf
  const pdflist = ['pdf']
  if (pdflist.find((item) => item === suffix)) {
    return 'pdf'
  }
  // 匹配 pdf
  const pptlist = ['ppt']
  if (pptlist.find((item) => item === suffix)) {
    return 'ppt'
  }
  // 匹配 txt
  const txtlist = ['txt']
  if (txtlist.find((item) => item === suffix)) {
    return 'txt'
  }
  return 'word' // 默认
}
</script>
<style scoped lang="scss">
.c999 {
  color: #999;
}
.flex1 {
  flex: 1;
}
.ant-progress-inner {
  height: 30px;
}
.upload-file-list {
  height: 30px;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 10px;
  border-radius: 4px;
  &:hover {
    .deleteIcon {
      img {
        color: #ff4c4c;
      }
    }
  }
}
.upload-progress {
  margin-top: 10px;
  position: relative;
}
.upload-progress-percent {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  margin-left: -36px;
  color: #fff;
  font-weight: 500;
}
.upload-file-list-edit {
  background: rgba(29, 76, 210, 0.1);
}
.upload-file-list-disabled {
  background: #f0f0f0;
  color: #666666;
}
.tips {
  margin-left: 8px;
  color: #aeb7d1;
  height: 30px;
  display: inline-block;
}
.upload-file-list-view {
  color: #1d4cd2;
}
:deep .ant-progress-inner {
  border-radius: 4px;
}
:deep .ant-progress-bg {
  border-radius: 4px;
}
:deep .ant-progress-text {
  display: none;
}
:deep .ant-progress-show-info .ant-progress-outer {
  padding-right: 0;
}
</style>
